export default class UnknownError extends Error {
  constructor({ status, code, message = 'Error', details, errors }) {
    super(...arguments);
    this.name = this.constructor.name;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }

    this.status = status;
    this.code = code;
    this.message = message;
    this.details = details;
    // Validation errors keyed by the path of a form field, e.g. of the repeat transaction confirm
    this.errors = errors;
  }
}
